import React from 'react';

const SayHello = () => {
    return (
        <div className="hear-container">
            <h1 className="hear-heading">
                We look forward to hearing from you!
            </h1>
            <div className="hear-you">
                <h2 className="hear-subheading">
                    Fill out the form below, and we will get back to you ASAP so you can bring home our quality, delicious beef!
                </h2>
            </div>
        </div>
    );
};

export default SayHello;
